import React, { FC, useEffect, useState } from 'react';
import { Nav } from 'react-bootstrap';
import useFilters from '../../common/components/SearchFilters/hooks/useFilters';
import TooltipWrapper from '../../common/components/TooltipWrapper';

interface TabProps {
  defaultType: string;
  setType: (type: string) => void;
}

const caseReportTypeOption = {
  paramKey: 'case_report_type',
  paramLabel: 'case_report_type',
};

const Tabs: FC<TabProps> = ({ defaultType, setType }) => {
  const [redirect, setRedirect] = useState<boolean>(false);
  const { filters, setFilter, getPathWithParams } = useFilters([
    caseReportTypeOption,
  ]);

  const handleClick = (value: string) => {
    setFilter('case_report_type', value);
    setType(value);
    setRedirect(true);
  };

  const caseReportType = () => {
    if (filters['case_report_type']) {
      return filters['case_report_type'];
    }
    return defaultType;
  };

  interface TabComponentProps {
    type: string;
    label: string;
    tooltipContent: string;
  }

  const Tab: FC<TabComponentProps> = ({ type, label, tooltipContent }) => {
    return (
      <Nav.Item>
        <Nav.Link
          className={caseReportType() === type ? 'active' : ''}
          onClick={() => handleClick(type)}
        >
          <TooltipWrapper tooltipContent={tooltipContent} placement="bottom">
            <span
              className="test-name font-weight-bold"
              style={{ cursor: 'pointer' }}
            >
              {label}
            </span>
          </TooltipWrapper>
        </Nav.Link>
      </Nav.Item>
    );
  };

  useEffect(() => {
    if (redirect) {
      setRedirect(false);
      window.location.href = getPathWithParams();
    }
  }, [redirect]);

  const tabsContainerStyle = {
    display: 'flex',
    flexDirection: 'column' as const
  };

  const tabsStyle = {
    display: 'flex',
    justifyContent: 'flex-start',
    borderBottom: '1px solid #ccc'
  };

  return (
    <React.Fragment>
      <div style={tabsContainerStyle}>
        <Nav variant="pills" style={tabsStyle}>
          <Tab
            type="priority"
            label="Priority"
            tooltipContent="Only includes cases that are open with abnormal results"
          />
          <Tab
            type="closed"
            label="Complete / Closed cases"
            tooltipContent="Only includes cases that are closed/complete"
          />
          <Tab
            type="all"
            label="All cases"
            tooltipContent="Includes all cases"
          />
        </Nav>
      </div>
    </React.Fragment>
  );
};

export default Tabs;
